import { LegalEntitySourcesService_legalEntitySourcesServiceGetStopsLatest } from '@festina/legalentity-general-types/legalentity/hooks/LegalEntitySourcesStopsService_legalEntitySourcesServiceGetStopsLatest'

export const useFetchLegalentitySourcesStopsLatest =
  LegalEntitySourcesService_legalEntitySourcesServiceGetStopsLatest.useSuspenseQuery
